














import { defineComponent, ref, useContext, useFetch, useRoute } from '@nuxtjs/composition-api';
import { SfHeading, SfLoader } from '@storefront-ui/vue';
import { CacheTagPrefix, useCache } from '@vue-storefront/cache';
import HTMLContent from '~/components/HTMLContent.vue';
import DynamicNavigation from '~/components/Navigation/DynamicNavigation.vue';
import OurPartnersSection from '~/components/sections/OurPartnersSection.vue';
import VideoSection from '~/components/sections/VideoSection.vue';
import LoadWhenVisible from '~/components/utils/LoadWhenVisible.vue';
import { useContent } from '~/composables';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import type { CmsPage } from '~/modules/GraphQL/types';
import { Breadcrumb } from '~/modules/catalog/types';
import { usePageStore } from '~/stores/page';

export default defineComponent({
  name: 'CmsPage',
  components: {
    HTMLContent,
    SfHeading,
    SfLoader,
    DynamicNavigation,
    LoadWhenVisible,
    OurPartnersSection,
    VideoSection,
  },
  setup() {
    const { routeData } = usePageStore();
    const { addTags } = useCache();
    const { error: nuxtError, i18n, localePath } = useContext();
    const { loadPage, loading, error } = useContent();
    const route = useRoute();

    const page = ref<CmsPage | null>(null);

    const breadcrumbs = ref<Breadcrumb[]>([
      {
        text: i18n.t('Home') as string,
        link: localePath('/'),
      },
      {
        text: '',
        link: route.value.path,
      },
    ]);

    useFetch(async () => {
      page.value = await loadPage({ identifier: routeData.identifier });
      breadcrumbs.value[breadcrumbs.value.length - 1].text = page.value.title;

      if (error?.value?.page || !page.value) nuxtError({ statusCode: 404 });

      addTags([{ prefix: CacheTagPrefix.View, value: routeData.identifier }]);
    });
    return {
      page,
      loading,
      breadcrumbs,
      identifier: routeData.identifier,
    };
  },
  head() {
    return getMetaInfo(this.page);
  },
});
